<script>
/* global axios */
// Botão de ligação ByCall no header da conversa. Só aparece quando a caixa é um
// provedor ByCall com "ligações" ativado. Ao clicar, abre o widget de chamada
// dentro da própria conversa (via emitter).
import { mapGetters } from 'vuex';
import { useAlert } from 'dashboard/composables';
import { emitter } from 'shared/helpers/mitt';
import ButtonV4 from 'dashboard/components-next/button/Button.vue';

export const ASTRACALL_START = 'astracall:start';

export default {
  components: { ButtonV4 },
  data() {
    return { config: null };
  },
  computed: {
    ...mapGetters({
      currentChat: 'getSelectedChat',
      accountId: 'getCurrentAccountId',
    }),
    inboxId() {
      return this.currentChat?.inbox_id;
    },
    phone() {
      return this.currentChat?.meta?.sender?.phone_number;
    },
    contactName() {
      return this.currentChat?.meta?.sender?.name;
    },
    avatar() {
      return this.currentChat?.meta?.sender?.thumbnail;
    },
    inboxName() {
      const inbox = this.$store.getters['inboxes/getInbox'](this.inboxId);
      return inbox?.name || '';
    },
    enabled() {
      return !!this.config?.enabled;
    },
  },
  watch: {
    inboxId: {
      immediate: true,
      handler() {
        this.checkConfig();
      },
    },
  },
  methods: {
    async checkConfig() {
      this.config = null;
      if (!this.inboxId) return;
      try {
        const { data } = await axios.get(
          `/api/v1/accounts/${this.accountId}/kanban/connections/call_config`,
          { params: { inbox_id: this.inboxId } }
        );
        this.config = data.data;
      } catch (e) {
        this.config = null;
      }
    },
    call() {
      if (!this.phone) {
        useAlert(this.$t('CONNECTIONS.call.noPhone'));
        return;
      }
      emitter.emit(ASTRACALL_START, {
        accountId: this.accountId,
        instanceName: this.config.instance_name,
        conversationId: this.currentChat?.id,
        phone: this.phone,
        name: this.contactName,
        avatar: this.avatar,
        location: this.inboxName,
      });
    },
  },
};
</script>

<template>
  <ButtonV4
    v-if="enabled"
    v-tooltip.top-end="$t('CONNECTIONS.call.tooltip')"
    icon="i-lucide-phone"
    slate
    faded
    sm
    @click="call"
  />
</template>
